"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonIcon = void 0;
var _ButtonIcon = require("./ButtonIcon");
// TODO: in v9, move styled() from ButtonIcon.jsx to here
var StyledButtonIcon = _ButtonIcon.ButtonIcon;
exports.StyledButtonIcon = StyledButtonIcon;